import {AbsenceEntry, AbsenceReason} from '@gt-api';
import * as moment from 'moment';
import {absenceActions} from './status.constants';
import {StatusModel} from './status.model';

export class StatusAbsentModel extends StatusModel {
  actionId: number;
  absenceId: number;
  defaultActionId: number;
  defaultDuration: string;
  readReason: boolean;
  defaultReadReason: boolean;
  readTime: boolean;
  defaultReadTime: boolean;
  tempLogoutAgent: boolean;
  defaultTempLogoutAgent: boolean;
  appointmentSubject: string;
  endTime: Date;
  startTime: Date;
  defaultOrganization: string;

  getForwardingText(): string {
    const target = absenceActions.find(e => e.key === this.actionId);
    if (target) {
      return target.text;
    } else {
      return '';
    }
  }

  initializeWithDefaultValues() {
    this.actionId = this.defaultActionId;
    this.readReason = this.defaultReadReason;
    this.readTime = this.defaultReadTime;
    this.tempLogoutAgent = this.defaultTempLogoutAgent;
  }

  getForwardingDelay(): number {
    return 0;
  }

  setStartTimeAsMoment() {
    const previous5Minute = Math.floor(moment().minute() / 5) * 5;
    const startTimeMoment = moment().minute(previous5Minute).second(0).millisecond(0);
    return startTimeMoment;
  }

  setTime(defaultString: string) {
    const startTimeMoment = this.setStartTimeAsMoment();
    this.startTime = startTimeMoment.toDate();
    if (defaultString) {
      const duration = Number(defaultString);
      if (duration) {
        this.endTime = startTimeMoment.add(duration, 'minutes').toDate();
      } else if (defaultString.includes('+')) {
        const timeAndDays = defaultString.split('+');
        this.endTime = moment(timeAndDays[0], 'HH:mm').add(timeAndDays[1], 'days').toDate();
      } else if (defaultString === '00:00') {
        this.endTime = moment().endOf('day').toDate();
      }
    }
  }

  createAbsenceEntry(oname: string, login?: string, absenceId?: number): AbsenceEntry {
    return {
      id: absenceId,
      actionId: this.actionId,
      reasonId: this.reasonId,
      startTime: this.startTime,
      endTime: this.endTime,
      readReason: this.readReason,
      readTime: this.readTime,
      tempLogoutAgent: this.tempLogoutAgent,
      // active: false,
      organization: oname,
      login
    };
  }

  createAbsenceReason(): AbsenceReason {
    return {
      id: this.reasonId,
      organization: this.defaultOrganization,
      defaultAction: this.defaultActionId,
      defaultDuration: this.defaultDuration,
      defaultReadAction: 0,
      defaultReadReason: this.defaultReadReason,
      defaultReadTime: this.defaultReadTime,
      defaultTempLogoutAgent: +this.defaultTempLogoutAgent
    };
  }
}
